import { useSelector } from 'react-redux';

import { areUserRolesIn } from '../../../../../helpers';
import { ALL_CLIENTS_ROLES } from '../constants';

import type { RootState } from '../../../../../store';
import type { HeaderUser } from '../types';
import type { TreatmentPlanV3HeaderState } from './types';

export default function useTreatmentPlanV3HeaderState(): TreatmentPlanV3HeaderState {
  const authUser = useSelector((state: RootState) => state.auth.user);
  const provider = useSelector((state: RootState) => state.providers.provider);
  const clinicalClients = useSelector((state: RootState) => state.clients.list);
  const allClients = useSelector((state: RootState) => state.clients.allClientsList);
  const selectedClient = useSelector((state: RootState) => state.clients.selected);
  const isClientsLoading = useSelector((state: RootState) => state.clients.loading);
  const treatmentPlan = useSelector((state: RootState) => state.treatmentPlans.current);
  const treatmentPlans = useSelector((state: RootState) => state.treatmentPlans.list);
  const activeTreatmentPlan = useSelector(
    (state: RootState) => state.treatmentPlans.activeTreatmentPlan,
  );
  const tpStatusIdByLabel = useSelector(
    (state: RootState) => state.treatmentPlans.tpStatusIdByLabel,
  );
  const isPlansLoading = useSelector(
    (state: RootState) => state.treatmentPlans.loading || state.treatmentPlans.currentTpLoading,
  );
  const isCurrentTpLoading = useSelector(
    (state: RootState) => state.treatmentPlans.currentTpLoading,
  );
  const recommendation = useSelector(
    (state: RootState) => state.treatmentRecommendations.recommendation,
  );
  const recommendationTpId = useSelector(
    (state: RootState) => state.treatmentRecommendations.treatmentPlanId,
  );
  const reportGoals = useSelector((state: RootState) => state.goals.tpReportGoalsList);
  const multiTrialSummary = useSelector((state: RootState) => state.sessions.multiTrialSummary);
  const isReportLoading = useSelector(
    (state: RootState) => state.sessions.loading || state.goals.loading,
  );

  const user: HeaderUser | null = authUser
    ? { roles: authUser.roles, email: authUser.email }
    : null;
  const clients = areUserRolesIn(user?.roles ?? [], ALL_CLIENTS_ROLES)
    ? allClients
    : clinicalClients;

  return {
    user,
    provider,
    clients,
    selectedClient,
    isClientsLoading,
    treatmentPlan,
    treatmentPlans,
    activeTreatmentPlan,
    tpStatusIdByLabel,
    isPlansLoading,
    isCurrentTpLoading,
    recommendation,
    recommendationTpId,
    reportGoals,
    multiTrialSummary,
    isReportLoading,
  };
}
